import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ITicket, ITicketListResponse, ITicketPayload, ITicketResponse } from '../models/ticket.model';

@Injectable({
    providedIn: 'root'
})
export class TicketService {

    private _activeTicket: BehaviorSubject<ITicket | null> = new BehaviorSubject<ITicket | null>(null);
    activeTicket$: Observable<ITicket | null> = this._activeTicket.asObservable();

    private _ticketCreado: Subject<void> = new Subject<void>();
    ticketCreado$: Observable<void> = this._ticketCreado.asObservable();

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Establece el ticket que se desea visualizar o editar.
     * @param ticket 
     */
    setActiveTicket(ticket: ITicket | null): void {
        this._activeTicket.next(ticket);
    }

    /**
     * Notifica que un ticket ha sido creado con éxito.
     */
    notificarTicketCreado(): void {
        this._ticketCreado.next();
    }

    /**
     * Recupera el listado de tickets asociados al proyecto del usuario.
     * @returns 
     */
    getTickets(): Observable<ITicketListResponse> {
        return this._httpClient.get<ITicketListResponse>(environment.soporte.listado_tickets);
    }

    /**
     * Crea un nuevo ticket en el sistema de sprint.
     * @param ticket 
     * @returns 
     */
    crearTicket(ticket: ITicketPayload): Observable<ITicketResponse> {
        return this._httpClient.post<ITicketResponse>(environment.soporte.crear_ticket, ticket);
    }

    /**
     * Intercambia la prioridad entre dos tickets.
     * @param idOrigen 
     * @param idDestino 
     * @returns 
     */
    intercambiarPrioridad(idOrigen: number, idDestino: number): Observable<any> {
        return this._httpClient.post<any>(environment.soporte.intercambiar_prioridad, {
            idticket_origen: idOrigen,
            idticket_destino: idDestino
        });
    }

    /**
     * Actualiza la prioridad de un ticket para desplazarlo.
     * @param idTicket 
     * @param prioridad 
     * @returns 
     */
    actualizarPrioridad(idTicket: number, prioridad: number, usuarioExternoNombre?: string): Observable<any> {
        const payload: any = {
            idticket: idTicket,
            prioridad: prioridad
        };
        if (usuarioExternoNombre) {
            payload.usuario_externo_nombre = usuarioExternoNombre;
        }
        return this._httpClient.post<any>(environment.soporte.actualizar_prioridad, payload);
    }
}
